import gql from 'graphql-tag';
import { getContextTMC } from '@/utils/tmc';

const query = gql`
  query fetchHotelPolicies(
    $hotelId: String
    $source: SuggestionSourceTypeEnum!
  ) {
    fetchHotelPolicies(hotelExtId: $hotelId, source: $source, tmc: "${getContextTMC()}") {
      hotelId
      policies
    }
  }
`;

export default function fetchHotelPolicies({ apollo, hotelId, source }) {
  return apollo.query({
    query,
    variables: {
      hotelId,
      source,
      getContextTMC
    }
  });
}
